import { render } from "./TicketInteligenteNew.vue?vue&type=template&id=82c770a4&scoped=true"
import script from "./TicketInteligenteNew.vue?vue&type=script&lang=js"
export * from "./TicketInteligenteNew.vue?vue&type=script&lang=js"

import "./TicketInteligenteNew.vue?vue&type=style&index=0&id=82c770a4&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82c770a4"]])

export default __exports__